import { useSearchParams } from '@remix-run/react'
import { Search } from 'lucide-react'

import { Badge } from './ui/badge.tsx'
import { Button } from './ui/button.tsx'
import { Input } from './ui/input.tsx'

export function SearchBar() {
	const [searchParams, setSearchParams] = useSearchParams()

	const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		const formData = new FormData(e.currentTarget)
		const searchTerm = formData.get('search')?.toString() ?? ''
		setSearchParams(searchParams => {
			searchParams.set('search', searchTerm)
			return searchParams
		})
	}

	return (
		<div className="relative mb-8">
			<form onSubmit={handleSearch} className="flex">
				<div className="relative flex-grow">
					<Search className="absolute left-3 top-1/2 -translate-y-1/2 transform text-slate-400" />
					<Input
						className="rounded-l-lg rounded-r-none border-r-0 py-6 pl-10 text-lg"
						placeholder="Search by sequence, MHC allele, source protein, structure type, source organism, reference, or IEDB id..."
						type="search"
						name="search"
						defaultValue={searchParams.get('search') ?? ''}
					/>
				</div>
				<Button
					className="h-[50px] rounded-l-none bg-blue-500 px-6 text-white hover:bg-blue-600"
					type="submit"
				>
					Search
				</Button>
			</form>
		</div>
	)
}
